<template>
  <v-fade-transition>
    <v-container v-if="!privacyConsentAnswered" class="dark consent-container color-new-dark-grey pa-6">
      <v-row no-gutters align="center" justify="space-between">
        <v-col cols="12" sm="8" md="9">
          <h4 class="text-h7 mt-0 white--text">{{ $t('cc-text-1') }}</h4>
          <span>{{ $t('cc-text-2') }}</span>
        </v-col>
        <v-col cols="12" sm="3" md="2" class="text-center" :class="{ 'pt-3' : this.$vuetify.breakpoint.smAndDown }">
          <div class="py-3">
            <v-btn tile block color="primary" @click="acceptAll">{{ $t('cc-text-3') }}</v-btn>
          </div>
          <div>
            <shared-privacy-dialog class="color-new-light-bluegrey--text text-subtitle-2" />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-fade-transition>
</template>

<script>
  export default {
    methods: {
      acceptAll() {
        this.$store.commit('cookiesAllowed', true)
        this.$store.commit('trackingAllowed', true)
        this.$store.commit('privacyConsentAnswered', true)
      }
    },
    computed: {
      privacyConsentAnswered() {
        return this.$store.getters.privacyConsentAnswered
      }
    }
  }
</script>

<style>
  .consent-container {
    position: fixed;
    bottom: 0;
    z-index: 1000000;
    left: -50%;
    right: -50%;
    border-radius: 8px;
    color: #E8E9ED;
  }
</style>

<i18n>
  {
  "fi": {
  "cc-text-1": "Haluamme palvella sinua paremmin",
  "cc-text-2": "Tallennamme tietoja palvelujemme käytöstä, jotta voimme parantaa käyttäjiemme asiakaskokemusta ja seurata palvelun teknistä toimivuutta. Emme luovuta tietoja kolmansille osapuolille.",
  "cc-text-3": "Hyväksy"
  },
  "se": {
  "cc-text-1": "Vi vill kunna ge dig bättre service",
  "cc-text-2": "Vi sparar uppgifter om hur vår tjänst används för att kunna förbättra användarvänligheten och för att kunna säkerställa den tekniska funktionaliteten för vår tjänst. Vi överlåter inte uppgifterna till någon tredje part.",
  "cc-text-3": "Godkänn"
  },
  "en": {
  "cc-text-1": "We want to provide you better services",
  "cc-text-2": "We collect data about the use of our services in order to improve customer experience and ensure the technical functionality of our systems. We do not share this data with third parties.",
  "cc-text-3": "Accept"
  }
  }
</i18n>
